<div class="app-action-tablet-header-station-tab" [ngClass]="{'selected': selected}" (click)="selectTab()">
  <sc-padding>
    <sc-flex [centered]="true" >
      <div class="label">{{stationName}}</div>
      @if (selected) {
        <sc-content-spacer></sc-content-spacer>
      }
      @if (selected) {
        <div class="close-action"><sc-icon iconClass="fa-times close-btn" (click)="closeTab()"></sc-icon></div>
      }
    </sc-flex>
  </sc-padding>
</div>